<template>
  <div v-if="sticker">
    <app-header :title="(originalName) ? 'Edit '+ originalName: 'New Sticker'" subtite="Sticker">
      <b-button variant="primary" @click="save()">
        Save Changes
      </b-button>
      <cancel-button />
    </app-header>
    <b-container>
      <b-row>
        <b-col md="4">
          <b-form name="editorForm">
            <!--Category-->
            <b-form-group>
              <label>Category</label><i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-select v-model="sticker.category_id" class="form-control">
                <b-form-select-option v-for="category in mediacategories" :key="category.id" :value="category.id">
                  {{ category.name }}
                </b-form-select-option>
              </b-form-select>
            </b-form-group>
            <!--Name-->
            <b-form-group>
              <label>Name</label> <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <b-form-input
                v-model="sticker.name"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
            <!--Tags-->
            <b-form-group>
              <label>Tags</label>
              <b-form-textarea v-model="sticker.tags" class="form-control"></b-form-textarea>
              <small class="form-text text-muted">
                Comma-separated keywords to help users find this theme.
              </small>
            </b-form-group>
            <!--thumbnail-->
            <b-form-group>
              <label>Thumbnail</label> <i class="fa fa-asterisk" style="font-size:8px;color:red" />
              <FileInput v-model="sticker.src" required folder="sticker/src" />
            </b-form-group>
          </b-form>
        </b-col>
        <b-col md="8"></b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import $api from '@/services/api';
import FileInput from '@/components/FileInput';
import CancelButton from '@/components/CancelButton';
import AppHeader from '@/components/AppHeader';

export default {
  components: {
    AppHeader,
    FileInput,
    CancelButton,
  },

  data() {
    return {
      originalName: null,
      sticker: null,
      mediacategories: null,
    };
  },

  created() {
    this.refreshData();
  },

  methods: {
    async refreshData() {
      this.mediacategories = await $api.get('/v1/internal/mediacategories');

      if (this.$route.query.id) {
        this.sticker = await $api.get(`/v1/internal/stickers/${this.$route.query.id}`);
        this.originalName = this.sticker.name;
      } else {
        this.sticker = {
          category_id: this.$route.query.category_id,
        };
      }
    },

    async save() {
      let sticker;
      if (this.sticker.id) {
        sticker = await $api.put(`/v1/internal/stickers/${this.sticker.id}`, this.sticker);
      } else {
        sticker = await $api.post('/v1/internal/stickers', this.sticker);
      }
      this.$router.push({
        name: 'sticker-detail',
        params: sticker,
      });
    },
  },
};
</script>
